<date-input (valueOut)="setElement($event, 1)" 
[initialPlaceHolder]="'Desde'" [value]="elementSelected" [isIncomplete]="isIncomplete"></date-input>

<span class="text-is-incomplete invalid-text" style="position:absolute;" *ngIf="isIncomplete">Se deben rellenar ambas fechas.</span>